<h2 mat-dialog-title>Dados do paciente</h2>
<mat-dialog-content>
  <div class="patient-info">
    <p><strong>CPF:</strong> {{ patient.cpf || '-' }}</p>
    <p><strong>Último atendimento:</strong> {{ patient.last_appointment ? layout.dateTimeFormat(patient.last_appointment) : '-' }}</p>
  </div>
  <h3>Alterar nome</h3>
  <mat-form-field appearance="outline" class="name-field">
    <mat-label>Nome</mat-label>
    <input matInput [formControl]="name" maxlength="200" />
    <mat-error *ngIf="name.hasError('required')">Informe o nome</mat-error>
    <mat-error *ngIf="name.hasError('maxlength')">Nome muito longo</mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="saving">Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="saving">Salvar</button>
</mat-dialog-actions>
